import BasicButton from "../../../../../ui library/components/buttons/BasicButton";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import BillListItem from "../BillListItem";
import { useEffect, useState } from "react";
import useService from "../../../../../../hooks/useService";
import { useUploadDocumentStore } from "../../hooks/useUploadDocumentStore";
import { CircularProgress, Typography } from "@mui/material";
import LoadingIndicator from "../../../../../global/LoadingIndicator";

const BillAccordionDetails = ({ accordionItemContent }) => {
  const administeredServiceRepository = useService(
    "repositories/administered-service-repository"
  );
  const [services, setServices] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const { serviceLimit, serviceOffset, provider } = useUploadDocumentStore();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchInitialServices = async () => {
      setLoading(true);
      if (!provider) {
        setLoading(false);
        return;
      }

      const administeredServices = await administeredServiceRepository.query({
        limit: serviceLimit,
        offset: serviceOffset,
      });

      const mapped =
        administeredServices?.map((item) => ({
          id: item.id,
          label: [item.serviceCode, item.serviceName],
        })) || [];

      setServices(mapped);

      const next = await administeredServiceRepository.getNextPage();
      setNextPage(next);
      setLoading(false);
    };

    fetchInitialServices();
  }, [provider]);

  return (
    <div className="flex flex-col w-full">
      {loading ? (
        <div className="flex w-full flex-row items-center justify-center p-2">
        <CircularProgress color="secondary" />
        </div>
      ) : (
        <>
          {services && services.length > 0 ? (
            accordionItemContent?.bills?.size > 0 && (
              <fieldset className="group px-4 py-2 border-[1px] mb-4 rounded-md border-gray-300 hover:border-gray-700">
                <legend className="p-1 text-xs text-gray-500">Bills</legend>
                {[...accordionItemContent.bills.entries()].map(([_, bill]) => (
                  <BillListItem
                    key={bill.id}
                    apptId={accordionItemContent.id}
                    bill={bill}
                    initialServices={services}
                    nextPage={nextPage}
                  />
                ))}
              </fieldset>
            )
          ) : (
            <Typography className="w-full text-center text-gray-500 p-2">
              No services to show. Please add new services to add bill/s.
            </Typography>
          )}

          <BasicButton
            variant="outlined"
            text="Add Bill"
            className="w-full px-4 py-2 text-green-600 items-center self-center text-lg hover:bg-green-100 border-green-600 hover:border-green-500"
            icon={<AddCircleOutlineRoundedIcon />}
            disabled={services.length === 0}
            onClick={() =>
              accordionItemContent.onAddBillBtnClick(accordionItemContent.id)
            }
          />
        </>
      )}
    </div>
  );
};

export default BillAccordionDetails;
